<template>
  <div class="planes-container">
    <div class="row justify-center q-col-gutter-md">
      <div
        v-for="plan in items"
        :key="plan.idplan || plan.nombre"
        class="col-12 col-sm-6 col-md-3 flex"
      >
        <div class="plan-card bg-white rounded-borders shadow-3 column justify-between full-width overflow-hidden">
          <div>
            <!-- Banner superior card -->
            <div class="plan-card-header bg-primary text-white text-center q-py-md relative-position">
              <div class="plan-badge-top"></div>
              <div class="text-subtitle1 text-weight-bold text-uppercase tracking-wide q-px-sm">
                {{ plan.nombre }}
              </div>
            </div>

            <!-- Precio -->
            <div class="text-center q-pa-md bg-blue-1 border-bottom">
              <div class="text-h4 text-weight-bolder text-primary">
                {{ plan.precio | currencyFilter("PEN", 2) }}
              </div>
              <div class="text-caption text-grey-7 text-weight-medium">
                (incluido I.G.V.)
              </div>
            </div>

            <!-- Detalle & Valoración -->
            <div class="q-pa-md">
              <div class="row items-center justify-center q-gutter-x-xs q-mb-sm text-amber-9">
                <span class="text-weight-bold text-body2">★ ★ ★ ★ ★</span>
                <span class="text-caption text-grey-6">(4.5)</span>
              </div>
              <div class="text-body2 text-grey-8 text-center line-height-relaxed q-mt-xs">
                {{ plan.descripcion }}
              </div>
            </div>
          </div>

          <!-- Botón de Acción -->
          <div class="q-pa-md bg-grey-1 text-center">
            <q-btn
              color="primary"
              label="SOLICITAR"
              unelevated
              no-caps
              class="full-width text-weight-bold rounded-borders shadow-2"
              @click="registro()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanesComponent",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    registro() {
      this.$router.push("/registro");
    },
  },
};
</script>

<style scoped>
.planes-container {
  width: 100%;
  padding: 10px 0;
}

.plan-card {
  border: 1px solid #e2e8f0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  min-height: 380px;
}

.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
}

.plan-card-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.tracking-wide {
  letter-spacing: 0.5px;
}

.line-height-relaxed {
  line-height: 1.5;
}
</style>
